import { Component, input, OnInit } from '@angular/core';
import { RDataPracticeViewModel } from '../models/rdata/r-data-practice-view-model';
import { ResolveLibModule } from "../resolve-lib.module";
import { CommonModule } from '@angular/common';
import { ProductionBonusType } from '../models/rdata/production-bonus-type';
import { RedactedComponent } from '../redacted/redacted.component';
import { SalaryRateDurationPipe } from "../pipes/salary-rate-duration/salary-rate-duration.pipe";

interface DetailsSection {
  header: string;
  fields: Field[]
}

interface Field {
  dataPoint: string;
  title: string;
}

@Component({
    selector: 'lib-rdata-details',
    imports: [
        ResolveLibModule,
        CommonModule,
        RedactedComponent,
        SalaryRateDurationPipe
    ],
    templateUrl: './rdata-details.component.html',
    styleUrl: './rdata-details.component.scss'
})
export class RdataDetailsComponent implements OnInit {

  contractDetails = input<RDataPracticeViewModel>();
  freeAccountView = input<boolean>(false);

  tableSections: DetailsSection[];


  ngOnInit(): void {
    this.tableSections = this.getTableSections();
    if(this.contractDetails()){
      if(!!this.contractDetails().productionBonusType){
        this.setBonusTypeFieldTitles(this.contractDetails());
      }
    }
  }

  getTableSections(): DetailsSection[] {
    return [
      {
        header: 'Employer',
        fields: [
          {dataPoint: 'specialty', title: 'Specialty'},
          {dataPoint: 'practiceType', title: 'Practice Type'},
          {dataPoint: 'positionType', title: 'Position Type'},
        ]
      },
      {
        header: 'Salary Information',
        fields: [
          {dataPoint: 'shiftRates', title: ''},
          {dataPoint: 'hourlyRates', title: ''}
        ]
      },
      {
        header: 'Other Salary Information',
        fields: [
          {dataPoint: 'signingBonus', title: 'Signing Bonus'},
          {dataPoint: 'relocationBonus', title: 'Relocation Bonus'},
          {dataPoint: 'productionBonusType', title: 'Production Bonus'},
          {dataPoint: 'bonusRate', title: 'Bonus Rate'},
          {dataPoint: 'bonusThreshold', title: 'Bonus Threshold'},
          {dataPoint: 'qualityBonus', title: 'Quality Bonus'}
        ]
      },
      {
        header: 'Additional Benefits',
        fields: [
          {dataPoint: 'cmeAllowance', title: 'Continuing Medical Education Allowance'},
          {dataPoint: 'cmeTime', title: 'Continuing Medical Education Time'},
          {dataPoint: 'pto', title: 'Paid Time Off'},
          {dataPoint: 'duesLicensePaid', title: 'Dues/License Paid'},
          {dataPoint: 'malpracticeType', title: 'Malpractice Type'},
          {dataPoint: 'malpracticeBenefitLimits', title: 'Malpractice Benefits Limits'},
          {dataPoint: 'tailCoverage', title: 'Tail Coverage'},
          {dataPoint: 'nonCompeteTimePeriod', title: 'Non-Compete Time Period'},
          {dataPoint: 'nonCompeteDistance', title: 'Non-Compete Distance'},
          {dataPoint: 'nonCompeteExclusions', title: 'Non-Compete Exclusions'}
        ]
      }
    ];
  }

  setBonusTypeFieldTitles(details: RDataPracticeViewModel){
    this.tableSections.map(section => 
      {
        if(details.productionBonusType === ProductionBonusType.Dollars){
          section.fields.map(field => {
            if(field.dataPoint === 'bonusThreshold'){
              field.title = 'Collections Threshold'
            }
          
            if(field.dataPoint === 'bonusRate'){
              field.title = 'Production Bonus Ratio'
            }
          }
          )
          return section
        }
        else if(details.productionBonusType === ProductionBonusType.Wrvu){
          section.fields.map(field => {
            if(field.dataPoint === 'bonusThreshold'){
              field.title = 'wRVU Threshold'
            }
          
            if(field.dataPoint === 'bonusRate'){
              field.title = '$/wRVU'
            }
          }
          )
          return section
        }

        return section;
      }
    )
  }

}
